<template>
  <div
    v-if="analyst"
    class="analysts-view"
  >
    <page-header :header="analyst.name">
      <template slot="subtitle">
        <div class="mt-1 mr-2">
          {{ analyst.job_title }}
          <span v-if="analyst.channel">
            <span v-if="analyst.job_title">
              @
            </span>

            <router-link
              v-if="$login.can('channels.view')"
              :to="`/channels/${analyst.channel.id}`"
            >
              {{ analyst.channel.name }}
            </router-link>

            <span v-else>
              {{ analyst.channel.name }}
            </span>
          </span>
        </div>
      </template>

    <!--   <button class="btn btn-outline-primary btn--more">
        <icon icon="more-vertical" />
      </button> -->
    </page-header>
    <tabs>
      <!-- Analytics tab -->
      <tab
        v-if="analyst && ($login.can('analytics.network') || ($login.can('analytics.channel') && analyst.channel.id === $login.getChannel().id))"
        name="Analytics"
      >
        <analytics :data="analyst" />
      </tab>

      <!-- Account Details tab -->
      <tab
        v-if="analyst"
        name="Details"
        class="mt-4"
      >
        <edit
          v-if="$login.can('analysts.update')"
          :data="analyst"
        />

        <read-only
          v-else
          :analyst="analyst"
        />
      </tab>
    </tabs>
  </div>
</template>

<script>
import {get} from '@/helpers'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

// TODO: update
import Edit from './Edit'

import Analytics from './Analytics'
import ReadOnly from './ReadOnly'

export default {
  components: {
    Tabs,
    Tab,
    Edit,
    Analytics,
    ReadOnly,
  },

  metaInfo () {
    return {
      title: this.analyst && this.analyst.name ? this.analyst.name : 'View Analyst',
    }
  },

  created () {
    this.getAnalyst(this.$route.params.analystId)
  },

  data () {
    return {
      analyst: null,
    }
  },

  methods: {
    async getAnalyst (id) {
      const {data} = await get(`analysts/${id}`)
      this.analyst = data.data
    },
  },
}
</script>
